export default __webpack_public_path__ + "static/8-f9754a7d0bdfe306fbb67b60338bc2c6.png";